// src/pages/SuperAdmin/components/RoleProfileSelectForBusiness.tsx
// Composant pour sélectionner un profil de rôle pour un business spécifique

import React from 'react';
import { Select } from 'antd';
import { useRoleProfilesByBusinessId } from '../../../hooks/useRoleProfiles';
import { normalizeSearch } from '../../../utils/searchUtils';

const { Option } = Select;

interface RoleProfileSelectForBusinessProps {
  businessId: string;
  value?: string;
  onChange?: (roleProfileId: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const RoleProfileSelectForBusiness: React.FC<RoleProfileSelectForBusinessProps> = ({
  businessId,
  value,
  onChange,
  placeholder = "Sélectionner un profil",
  disabled = false,
}) => {
  const { data: roleProfiles = [], isLoading } = useRoleProfilesByBusinessId(businessId);

  return (
    <Select
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled || isLoading || !businessId}
      loading={isLoading}
      showSearch
      optionLabelProp="label"
      filterOption={(input, option) => {
        const label = String(option?.label ?? '');
        const text = normalizeSearch(label);
        const search = normalizeSearch(input);
        if (!search) return true;
        const tokens = search.split(/\s+/).filter(Boolean);
        return tokens.every(token => text.includes(token));
      }}
    >
      {roleProfiles
        .filter(profile => profile.isActive)
        .map((profile) => (
          <Option 
            key={profile.id} 
            value={profile.id}
            label={profile.name}
          >
            <div>
              <div>{profile.name}</div>
              {profile.description && (
                <div style={{ fontSize: '12px', color: '#999' }}>
                  {profile.description}
                </div>
              )}
            </div>
          </Option>
        ))}
    </Select>
  );
};

export default RoleProfileSelectForBusiness;

